<span class="item-marker" [style.background]="background()"></span>

<span class="item-details truncate" [class.item-details--hidden]="hidden()">
  <span class="item-details__label truncate" [title]="label()">{{ label() }}</span>

  <!-- NOTE: Space if forced using non-breaking spaces as we need consistent line-through text decoration -->
  <span class="item-details__value" [title]="formattedValue()">&nbsp;&nbsp;{{ formattedValue() }}</span>
</span>
